import type { PeakFlowEstimate } from '../../types';

interface Props {
  peakFlows: PeakFlowEstimate[];
}

export default function PeakFlowPanel({ peakFlows }: Props) {
  if (!peakFlows || peakFlows.length === 0) {
    return (
      <div className="panel">
        <div className="panel-title">Peak Flows</div>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>
          Peak flow estimates unavailable.
        </p>
      </div>
    );
  }

  return (
    <div className="panel">
      <div className="panel-title">Peak Flow Estimates (USGS Regression)</div>
      <table className="peak-flow-table">
        <thead>
          <tr>
            <th>Return Period</th>
            <th>AEP</th>
            <th>Flow (cfs)</th>
          </tr>
        </thead>
        <tbody>
          {peakFlows.map((pf) => (
            <tr key={pf.return_period_years}>
              <td>{pf.return_period_years}-year</td>
              <td>{(pf.annual_exceedance_prob * 100).toFixed(1)}%</td>
              <td>
                {pf.flow_cfs.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginLeft: '0.25rem' }}>
                  ({pf.lower_ci_cfs.toLocaleString(undefined, { maximumFractionDigits: 0 })}–
                  {pf.upper_ci_cfs.toLocaleString(undefined, { maximumFractionDigits: 0 })})
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '0.5rem' }}>
        Based on Bell & Tillery (2023) NM regional regression equations.
        Values in parentheses show 90% confidence interval.
      </p>
    </div>
  );
}
